import React from "react";
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
} from "chart.js";
import { Pie } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, ChartDataLabels);

const AgegroupOrderChart = ({ ageGroupOrderData}) => {
    // tính tổng tất cả order
    // const totalOrder = ageGroupOrderData.reduce((sum, item) => sum + item.orders, 0)
    // // tính phần trăm
    // const percentData = ageGroupOrderData.map(data => ((data.orders / totalOrder) * 100).toFixed(2))
    const data = {
        labels: ageGroupOrderData.slice(0, 5).map(label => label.targetName),
        datasets: [
            {
                label: "Tỷ lệ đơn hàng theo độ tuổi",
                data: ageGroupOrderData.slice(0, 5).map(data => data.salePercent === 0 ? null : data.salePercent.toFixed(2)),
                backgroundColor: [
                    "#FF6384", 
                    "#36A2EB",
                    "#FFCE56",
                    "#4BC0C0",
                    "#9966FF",
                ],
                hoverBackgroundColor: [
                    "#FF6384",
                    "#36A2EB",
                    "#FFCE56",
                    "#4BC0C0",
                    "#9966FF",
                ],
            },
        ],
    };
    
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            datalabels: {
                color: "white",
                formatter: (value) => value !== null ? `${value}%` : '',
                font: {
                weight: "bold",
                size: 13,
                },
                anchor: "center",
                align: "center", // Căn chỉnh
            },
            tooltip: {
                callbacks: {
                    //nội dung khi hover vào từng phần
                    label: function (tooltipItem) {
                        const index = tooltipItem.dataIndex;
                        const totalSales = ageGroupOrderData[index].totalSales;
                        return `Số lượng đơn hàng bán được: ${totalSales}`;
                    },
                },
            },
            legend: {
                position: "bottom",
                labels: {
                    boxWidth: 20,
                    padding: 10,
                    usePointStyle: true, // Sử dụng hình tròn trong legend
                    boxHeight: 10,
                },
                align: 'start', // Đặt legend theo chiều ngang
                fullWidth: false, // Không kéo dài toàn bộ chiều rộng
            },
        },
    };
    return (
        <div>
           <Pie data={data} options={options} height={300}/>
        </div>
    );
};

export default AgegroupOrderChart;
